import { omit } from 'lodash'

import { serverResponse } from 'app'

import * as actions from '../../actions/matchBiosecurity'

export const getMatchBiosecInitialState = () =>
  serverResponse({
    fields: {},
    nin: {},
    serverResponse: {},
  })

export default (state = getMatchBiosecInitialState(), action = {}) => {
  switch (action.type) {
    case actions.TRN_MATCH_BIOSEC_FETCH: {
      return {
        ...state,
        loading: true,
      }
    }
    case actions.TRN_MATCH_BIOSEC_FETCH_CANCELED: {
      return {
        ...state,
        ...action.payload,
        loaded: false,
        loading: false,
      }
    }
    case actions.TRN_MATCH_BIOSEC_FETCH_ERROR: {
      return {
        ...state,
        ...action.payload,
        loaded: true,
        loading: false,
      }
    }
    case actions.TRN_MATCH_BIOSEC_FETCH_FULFILLED: {
      return {
        ...state,
        ...action.payload,
        loaded: true,
        loading: false,
      }
    }

    case actions.TRN_MATCH_BIOSEC_NIN_FETCH: {
      return {
        ...state,
        nin: serverResponse({}, { loading: true }),
      }
    }
    case actions.TRN_MATCH_BIOSEC_NIN_FETCH_CANCELED: {
      return {
        ...state,
        nin: {},
      }
    }
    case actions.TRN_MATCH_BIOSEC_NIN_FETCH_ERROR: {
      return {
        ...state,
        nin: {
          ...action.payload,
          loaded: true,
        },
      }
    }
    case actions.TRN_MATCH_BIOSEC_NIN_FETCH_FULFILLED: {
      return {
        ...state,
        nin: {
          ...action.payload,
          loaded: true,
        },
      }
    }

    case actions.TRN_MATCH_BIOSEC_RESET: {
      return getMatchBiosecInitialState()
    }
    case actions.TRN_MATCH_BIOSEC_SAVE_FETCH: {
      return {
        ...state,
        serverResponse: serverResponse({}, { loading: true }),
      }
    }
    case actions.TRN_MATCH_BIOSEC_SAVE_FETCH_CANCELED: {
      return {
        ...state,
        serverResponse: {},
      }
    }
    case actions.TRN_MATCH_BIOSEC_SAVE_FETCH_ERROR: {
      return {
        ...state,
        serverResponse: action.payload,
      }
    }

    case actions.TRN_MATCH_BIOSEC_SAVE_FETCH_FULFILLED: {
      return {
        ...state,
        serverResponse: action.payload,
      }
    }
    case actions.TRN_MATCH_BIOSEC_VALUES: {
      return {
        ...state,
        fields: {
          ...state.fields,
          ...action.payload,
        },
      }
    }
    case actions.TRN_MATCH_BIOSEC_VALUES_CLEANUP: {
      return {
        ...state,
        fields: {},
      }
    }
    case actions.TRN_MATCH_BIOSEC_VALUES_REMOVE: {
      return {
        ...state,
        fields: omit(state.fields, action.payload),
      }
    }

    default:
  }
  return state
}
